import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Prevent Angular Fire from auto-enabling App Check debug mode in non-optimized builds.
(globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN = false;

bootstrapApplication(AppComponent, appConfig)
   .catch((err) => console.error(err));
